/* eslint-disable @typescript-eslint/no-require-imports */
import type * as StatsigReactTypes from '@statsig/react-bindings';
import type * as StatsigLegacyTypes from 'statsig-react';
import { getCookie } from '~/utils/dom.utils';
import { isDevelopment } from '~/utils/environment.utils';

export const isNewStatsigSDK = () =>
    isDevelopment() ||
    !!getCookie('statsig_should_use_new_sdk') ||
    !!window.gon?.statsig_should_use_new_sdk;

export const getStatsigProviderComponent = () =>
    isNewStatsigSDK()
        ? statsigImport('StatsigProvider')
        : statsigLegacyImport('StatsigProvider');

export const isNewStatsigProvider = (
    provider:
        | typeof StatsigReactTypes.StatsigProvider
        | typeof StatsigLegacyTypes.StatsigProvider
): provider is typeof StatsigReactTypes.StatsigProvider => {
    return isNewStatsigSDK();
};

export function statsigImport<K extends keyof typeof StatsigReactTypes>(
    moduleName: K
): (typeof StatsigReactTypes)[K] {
    return require('@statsig/react-bindings')[moduleName];
}

export function statsigLegacyImport<K extends keyof typeof StatsigLegacyTypes>(
    moduleName: K
): (typeof StatsigLegacyTypes)[K] {
    return require('statsig-react')[moduleName];
}
